import VeeValidate from 'vee-validate';
import app from './_app';

const { Vue } = window;

Vue.use(VeeValidate);

window.quickWinsApp = new Vue(app);